import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Usuario} from "../../models/usuario";
import {ValidatorService} from "../../core/services/validator.service";
import {LoginService} from "../../services/login.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {MessageService} from "../../core/services/message.service";
import {Login} from "../../models/login";
import {Perfil} from "../../models/perfil";
import {isUndefined} from "util";
import {MatDialog} from "@angular/material";
import {DialogSolicitarAcessoComponent} from "../dialogs/dialog-solicitar-acesso/dialog-solicitar-acesso.component";

@Component({
    selector: 'app-login-externo',
    templateUrl: './login-externo.component.html',
    styleUrls: ['./login-externo.component.scss']
})
export class LoginExternoComponent implements OnInit {

    public usuario: Usuario;
    public form: FormGroup;

    constructor(private loadingService: NgxSpinnerService, private messageService: MessageService, private loginService: LoginService, private route: ActivatedRoute, private router: Router, private dialog: MatDialog) {

    }

    ngOnInit() {
        let login: Login = this.loginService.getAuth();

        if (login) {
            console.log(login);
            if (this.route.snapshot.params.perfil) {
                this.logout();
            } else {
                let url: string = "/usuario-externo";
                if (login.flg_externo) {

                    this.router.navigateByUrl(url);
                }
            }
        }
        this.usuario = new Usuario();
        this.form = new FormGroup({
            num_cpf: new FormControl(this.usuario.num_cpf, [
                Validators.required,
                ValidatorService.cpf
            ]),
            txt_senha: new FormControl(this.usuario.txt_senha, [
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(30)
            ])
        });
    }

    login(): void {
        if (this.form.valid) {
            this.loadingService.show();
            this.loginService.loginUsuarioExterno(this.form.get("num_cpf").value, this.form.get("txt_senha").value).subscribe((login: Login) => {
                window.location.reload(true);
                setTimeout(() => {
                    this.loadingService.hide();
                }, 3000);
            }, (error) => {
                this.loadingService.hide();
                this.messageService.showResponseError(error);
            });
        }
    }

    logout(): void {
        this.loadingService.show();
        this.loginService.logout();
        this.router.navigateByUrl("/login");
        setTimeout(() => {
            window.location.reload(true);
        }, 100);
    }
}
